// export const CDNurl = 'https://storage-api.pixray.com/Download/Image/';
export const CDNurl = 'https://storage-api.pixray.com/v1/documents/';
export const LogsInterval = 60000;
export const ACCOUNT_PORTAL_URL = 'https://test.account.pixray.com';
export const FLP_PORTAL_URL = 'https://flpportal.test.account.pixray.com';
